import { useQuery } from '@tanstack/react-query'
import { TemplatesApi } from '@ulysses-inc/harami_api_client'
import { queryKeys } from 'src/features/reportExport/detail/api/queryKeys'
import { baseClient } from 'src/state/middleware/saga/baseClient'

export const useQueryTemplates = () => {
  return useQuery({
    queryKey: queryKeys.templates,
    queryFn: () => baseClient.getApi(TemplatesApi).listTemplates(),
    select: data =>
      data.templates.map(template => ({
        id: template.id,
        name: template.name,
      })),
    // 画面を二回目以降に開く際に、時間差でデータが更新されることによる事故を防ぐため
    gcTime: 0,
  })
}
